export const INTEGRATION_MOVEMENTS_SET_LOADING =
  'INTEGRATION_MOVEMENTS/SET_LOADING';
export const INTEGRATION_MOVEMENTS_SET_ERROR =
  'INTEGRATION_MOVEMENTS/SET_ERROR';
export const INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT =
  'INTEGRATION_MOVEMENTS/SET_INTEGRATION_MOVEMENT';
export const INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENTS =
  'INTEGRATION_MOVEMENTS/SET_INTEGRATION_MOVEMENTS';
export const INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT_TYPES =
  'INTEGRATION_MOVEMENTS/SET_INTEGRATION_MOVEMENT_TYPES';
export const INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT_STATES =
  'INTEGRATION_MOVEMENTS/SET_INTEGRATION_MOVEMENT_STATES';
export const INTEGRATION_MOVEMENTS_SET_PAGINATION =
  'INTEGRATION_MOVEMENTS/SET_PAGINATION';

export const INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENT =
  'INTEGRATION_MOVEMENTS/FETCH_INTEGRATION_MOVEMENT';
export const INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENTS =
  'INTEGRATION_MOVEMENTS/FETCH_INTEGRATION_MOVEMENTS';
export const INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENT_TYPES =
  'INTEGRATION_MOVEMENTS/FETCH_INTEGRATION_MOVEMENT_TYPES';
export const INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENT_STATES =
  'INTEGRATION_MOVEMENTS/FETCH_INTEGRATION_MOVEMENT_STATES';
export const INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT_AS_MANAGED =
  'INTEGRATION_MOVEMENTS/SET_INTEGRATION_MOVEMENT_AS_MANAGED';
export const INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT_AS_NOT_CONSIDERED =
  'INTEGRATION_MOVEMENTS/SET_INTEGRATION_MOVEMENT_AS_NOT_CONSIDERED';
export const INTEGRATION_MOVEMENTS_CLEAR_ERROR =
  'INTEGRATION_MOVEMENTS/CLEAR_ERROR';

export const INTEGRATION_MOVEMENTS_GET_INTEGRATION_MOVEMENT =
  'INTEGRATION_MOVEMENTS/GET_INTEGRATION_MOVEMENT';
export const INTEGRATION_MOVEMENTS_GET_INTEGRATION_MOVEMENTS =
  'INTEGRATION_MOVEMENTS/GET_INTEGRATION_MOVEMENTS';
export const INTEGRATION_MOVEMENTS_GET_INTEGRATION_MOVEMENT_TYPES =
  'INTEGRATION_MOVEMENTS/GET_INTEGRATION_MOVEMENT_TYPES';
export const INTEGRATION_MOVEMENTS_GET_INTEGRATION_MOVEMENT_STATES =
  'INTEGRATION_MOVEMENTS/GET_INTEGRATION_MOVEMENT_STATES';
export const INTEGRATION_MOVEMENTS_GET_PAGINATION =
  'INTEGRATION_MOVEMENTS/GET_PAGINATION';
export const INTEGRATION_MOVEMENTS_GET_LOADING =
  'INTEGRATION_MOVEMENTS/GET_LOADING';
export const INTEGRATION_MOVEMENTS_GET_ERROR =
  'INTEGRATION_MOVEMENTS/GET_ERROR';
